import { useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import {
  $bookingCar,
  rentalContactCreationFormSubmit,
  rentalContactCreationRequestFx,
} from '~/features/BookingCars/BookingCar/model'
import { BookingCarDrawer, FormValues } from '~/entities/BookingCar'
import { driverModel } from '~/entities/Driver'
import { LeadProposalFullRegistrationDrawer } from '~/entities/Registration'
import { rentalServiceModel } from '~/entities/RentalService'
import { RentalService } from '~/shared/api'
import { Button } from '~/shared/ui/Buttons'
import { useDrawer } from '~/shared/ui/Drawer'
import { BookingButton } from './BookingButton'

type BookingAuthProps = {
  formValues: FormValues
}

export function BookingAuth({ formValues }: BookingAuthProps) {
  const [isBookingCarDrawerShow, openBookingCarDrawer, closeBookingCarDrawer] =
    useDrawer()

  const [
    isLeadProposalFullRegistrationDrawerShow,
    openLeadProposalFullRegistrationDrawer,
    closeLeadProposalFullRegistrationDrawer,
  ] = useDrawer()

  const driverIsLead = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getIsLead(),
  )

  const bookingCar = useStore($bookingCar)
  const isSubmitting = useStore(rentalContactCreationRequestFx.pending)
  const cancellationFeeRub = bookingCar?.getCancellationFeeRub()

  const location = useStoreMap($bookingCar, (bookingCar) =>
    bookingCar?.getLocation(),
  )
  const rentalServices = useStoreMap(
    rentalServiceModel.$rentalServices,
    (rentalServices) => rentalServices || [],
  )

  const selectedServicesIds = Object.entries(formValues.rentalServices || {})
    .filter(([, isSelected]) => isSelected)
    .map(([id]) => id)

  const filteredRentalServices = useMemo(
    () =>
      selectedServicesIds
        .map((selectedServicesId) =>
          rentalServices.find(
            (rentalService) => rentalService.getApiId() === selectedServicesId,
          ),
        )
        .filter(
          (rentalService): rentalService is RentalService => !!rentalService,
        ),
    [rentalServices, selectedServicesIds],
  )

  const handleBooking = () => {
    driverIsLead
      ? openLeadProposalFullRegistrationDrawer()
      : rentalContactCreationFormSubmit({
          formValues,
          closeDrawer: closeBookingCarDrawer,
        })
  }

  return (
    <>
      <BookingButton onClick={openBookingCarDrawer} />

      <BookingCarDrawer
        isShow={isBookingCarDrawerShow}
        onCancel={closeBookingCarDrawer}
        location={location}
        disabled={isSubmitting}
        cancellationFeeRub={cancellationFeeRub}
        rentalServices={filteredRentalServices}
      >
        <Button
          size='large'
          data-testid='button-booking-car-drawer'
          fullWidth
          variant='limeFlooded'
          onClick={handleBooking}
          style={{ marginBottom: '8px' }}
          loading={isSubmitting}
        >
          Забронировать
        </Button>
      </BookingCarDrawer>

      <LeadProposalFullRegistrationDrawer
        isShow={isLeadProposalFullRegistrationDrawerShow}
        onCancel={closeLeadProposalFullRegistrationDrawer}
      />
    </>
  )
}
